// Application roots.
// TODO: It is incomplete set, we should move all such literals here.

import type { ConfigT } from './config';

// -----------------------------------------------------------------------------
// Sub-domains.
export const SUB_DOMAIN_ADMIN = 'admin';
export const SUB_DOMAIN_AIAPP = 'ai';

// -----------------------------------------------------------------------------
// Base URLs for different app segments.

export function getAdminBaseUrl(config: ConfigT): string {
  return `${config.HTTP_SCHEMA}${SUB_DOMAIN_ADMIN}.${config.DOMAIN}`;
}

// -----------------------------------------------------------------------------
// Endpoints.

export const E_ABOUT = '/about';
export const E_ADD_NEW = '/add-new';
export const E_ADMIN_USERS = '/admin-users';
export const E_AI = '/ai';
export const E_AI_PROFILE = '/ai-profile';
export const E_API = '/__api__';
export const E_ARTIST = '/artist';
export const E_ASSETS = '/assets';
export const E_AUTH = '/auth';
export const E_AVATAR = '/avatar';
export const E_BETA_TESTER = '/beta-tester';
export const E_BLOG = '/blog';
export const E_BUILD_META = '/build-meta';
export const E_CATEGORY = '/category';
export const E_CHECK_IN = '/check-in';
export const E_CONTACT = '/contact';
export const E_CONTENT_MANAGEMENT = '/content-management';
export const E_DATA_EXPORT = '/data-export';
export const E_DOCUMENTS = '/documents';
export const E_EXPERIENCE = '/experience';
export const E_EXPERIENCES = '/experiences';
export const E_FILE = '/file';
export const E_FROM_INTERVIEW = '/from-interview';
export const E_GALLERY = '/gallery';
export const E_GENERIC_VIDEO = '/generic-video';
export const E_HOW_IT_WORKS = '/how-it-works';
export const E_ID = '/:id';
export const E_INTRO_VIDEO = '/intro-video';
export const E_INVOICING = '/invoicing';
export const E_LINKS = '/links';
export const E_MEDIA = '/media';
export const E_MODALITIES = '/modalities';
export const E_NEWSLETTER = '/newsletter';
export const E_ONBOARDING = '/onboarding';
export const E_PASSWORD_RESET_INIT = '/password-reset-init';
export const E_PASSWORD_RESET = '/password-reset';
export const E_PERFORMANCE = '/performance';
export const E_PRACTITIONERS = '/practitioners';
export const E_PROFILE = '/profile';
export const E_PROFILE_HERO_IMAGE = '/profile-hero-image';
export const E_QUESTIONNAIRE = '/questionnaire';
export const E_REALTIME_SESSION = '/realtime-session';
export const E_RESEARCH_LIB = '/research-lib';
export const E_SCIENCE = '/science';
export const E_SCORES = '/scores';
export const E_SESSION = '/session';
export const E_SESSION_LOGIN = '/session-login';
export const E_SESSION_LOGOUT = '/session-logout';
export const E_STATS = '/stats';
export const E_SUBMIT = '/submit';
export const E_SUGGEST = '/suggest';
export const E_TERMS = '/terms';
export const E_THE_SCIENCE = '/the-science';
export const E_TRANSCRIPT = '/transcript';
export const E_UPLOAD_IMAGE = '/upload-image';
export const E_USER_ID = '/:userId';
export const E_USERS = '/users';
export const E_VIDEO = '/video';
export const E_VIMEO_VIDEO = '/vimeo-video';
export const E_VIMEO_SOURCES = '/vimeo-sources';
export const E_YOU_MAY_ALSO_LIKE = '/you-may-also-like';

// -----------------------------------------------------------------------------
// Complete paths (from the root).

export const P_API_BLOG = `${E_API}${E_BLOG}`;

export const P_API_AI_BUILD_META = `${E_API}${E_AI}${E_BUILD_META}`;
export const P_API_AI_REALTIME_SESSION = `${E_API}${E_AI}${E_REALTIME_SESSION}`;
export const P_API_ARTIST = `${E_API}${E_ARTIST}`;
export const P_API_ASSETS = `${E_API}${E_ASSETS}`;
export const P_API_DATA_EXPORT = `${E_API}${E_DATA_EXPORT}`;
export const P_API_EXPERIENCES = `${E_API}${E_EXPERIENCES}`;
export const P_API_EXPERIENCES_SUGGEST = `${P_API_EXPERIENCES}${E_SUGGEST}`;

export const P_API_AUTH = `${E_API}${E_AUTH}`;
export const P_API_AUTH_PASSWORD_RESET = `${P_API_AUTH}${E_PASSWORD_RESET}`;
export const P_API_AUTH_PASSWORD_RESET_INIT = `${P_API_AUTH}${E_PASSWORD_RESET_INIT}`;
export const P_API_AUTH_SESSION_LOGOUT = `${P_API_AUTH}${E_SESSION_LOGOUT}`;
export const P_API_CONTACT = `${E_API}${E_CONTACT}`;

export const P_API_GENERIC_VIDEO = `${E_API}${E_GENERIC_VIDEO}`;

export const P_API_NEWSLETTER = `${E_API}${E_NEWSLETTER}`;

export const P_API_QUESTIONNAIRE = `${E_API}${E_QUESTIONNAIRE}`;
export const P_API_QUESTIONNAIRE_FROM_INTERVIEW = `${P_API_QUESTIONNAIRE}${E_FROM_INTERVIEW}`;

export const P_API_RESEARCH_LIB_CATEGORY = `${E_API}${E_RESEARCH_LIB}${E_CATEGORY}`;
export const P_API_RESEARCH_LIB_LINKS = `${E_API}${E_RESEARCH_LIB}${E_LINKS}`;

export const P_API_SESSIONS = `${E_API}${E_SESSION}`;
export const P_API_SESSION = `${P_API_SESSIONS}${E_ID}`;

export const P_API_USERS = `${E_API}${E_USERS}`;

export const P_API_USER_BETA_TESTER
  = (id: string): string => `${P_API_USERS}/${id}${E_BETA_TESTER}`;

export const P_API_ADMIN_USERS = `${P_API_USERS}${E_ADMIN_USERS}`;
export const P_API_UPLOAD_IMAGE = `${E_API}${E_UPLOAD_IMAGE}`;
export const P_API_USER_ARTIST = `${P_API_USERS}${E_ID}${E_ARTIST}`;
export const P_API_USER_AVATAR = `${P_API_USERS}${E_ID}${E_AVATAR}`;
export const P_API_VIDEO = `${E_API}${E_VIDEO}`;
export const P_API_VIMEO_VIDEO = `${E_API}${E_VIMEO_VIDEO}`;
export const P_API_VIMEO_SOURCES = `${E_API}${E_VIMEO_SOURCES}`;

export const P_ADMIN_ADMIN_USERS = E_ADMIN_USERS;
export const P_ADMIN_BLOG = E_BLOG;
export const P_ADMIN_CONTENT_MANAGEMENT = E_CONTENT_MANAGEMENT;
export const P_ADMIN_PASSWORD_RESET = '/password';
export const P_ADMIN_PRACTITIONERS = E_PRACTITIONERS;
export const P_ADMIN_PROFILE = E_PROFILE;
export const P_ADMIN_PROFILE_INTRO_VIDEO = `${P_ADMIN_PROFILE}${E_INTRO_VIDEO}`;
export const P_ADMIN_ADD_NEW_ADMIN_USER = `${P_ADMIN_ADMIN_USERS}${E_ADD_NEW}`;
export const P_ADMIN_ADD_NEW_PRACTITIONER = `${P_ADMIN_PRACTITIONERS}${E_ADD_NEW}`;
export const P_ADMIN_ADD_NEW_VIDEO = `${P_ADMIN_CONTENT_MANAGEMENT}${E_ADD_NEW}`;
export const P_ADMIN_RESEARCH_LIB = E_RESEARCH_LIB;
export const P_ADMIN_USERS = E_USERS;

export const P_AIAPP_CHECK_IN = E_CHECK_IN;
export const P_AIAPP_EXPERIENCE = E_EXPERIENCE;
export const P_AIAPP_ONBOARDING = E_ONBOARDING;
export const P_AIAPP_PASSWORD_RESET = E_PASSWORD_RESET;
export const P_AIAPP_SESSION = E_SESSION;
export const P_AIAPP_STATS = E_STATS;

export const P_WEBSITE_ABOUT = E_ABOUT;
export const P_WEBSITE_CONTACT = E_CONTACT;
export const P_WEBSITE_EXPERIENCE = E_HOW_IT_WORKS;
export const P_WEBSITE_HOME = '/';

export const P_WEBSITE_PRACTITIONERS = E_PRACTITIONERS;
export const P_WEBSITE_PRACITIONER_APPLICATION_FORM = `${P_WEBSITE_PRACTITIONERS}#application-form`;

export const P_WEBSITE_SCIENCE = E_THE_SCIENCE;
export const P_WEBSITE_TERMS = E_TERMS;
export const P_WEBSITE_BLOG = `${P_WEBSITE_SCIENCE}${E_BLOG}`;
